module.exports = __webpack_public_path__ + "static/media/p6a2.4480e33b.ogg";